import {Injectable} from "@angular/core";
import {filter, Subject, Subscription} from "rxjs";
import {map} from "rxjs/operators";
import {ToastrService} from "ngx-toastr";

export enum Events {
    ValidationFailed
}

export class EmitEvent {
    constructor(public name: Events, public value?: any) { }
}

@Injectable({
    providedIn: 'root'
})
export class EventBus {

    constructor(
        private toaster: ToastrService
    ) {
        this.on(Events.ValidationFailed, (val?: any) => this.validationError(val))
    }

    private subject = new Subject<any>();

    public emit(event: EmitEvent): void {
        this.subject.next(event);
    }

    public on(event: Events, action: any): Subscription {
        return this.subject
            .pipe(
                filter((e: EmitEvent) => e.name === event),
                map((e: EmitEvent) => e.value),
            )
            .subscribe(action);
    }

    private validationError(val?: string) {
        let msg = "Impossibile eseguire l'operazione: ci sono degli errori di validazione"
        if(val)
            msg += ": " + val
        this.toaster.error(msg)
    }

}
